import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition, SubTask } from "../common/models";
import { randomUUID } from "../../../utils";
import { translateReactNode } from "../../../../utils/translateReactNode";

const Definition: AcousticTaskDefinition = {
  name: "Picture description",
  title: "Picture description",
  description: "This task helps us analyze features in your voice.",
  cohort: 'generic',
  type: 'acoustic-task',
  estimatedCompletionTime: '1:10',
  subTaskDefinitions: [{
    name: "Picture description-option1",
    title: "",
    instructions: `Tell me everything you see going on in this picture.`,
    profileName: 'speech',
    content: <img src='assets/images/PictureDescriptionTaskPicture1.png' alt="subTak" className="subTak-image"
    style={{
      width: '100%',
      height: 'auto',
      maxWidth: '600px'
    }} />
  }, {
    name: "Picture description-option2",
    title: "",
    instructions: `Describe everything that is happening in the picture (as though describing it for the blind), trying to use complete sentences.`,
    profileName: 'speech',
    content: <img src='assets/images/PictureDescriptionTaskPicture2.jpg' alt="subTak" className="subTak-image"
    style={{
      width: '100%',
      height: 'auto',
      maxWidth: '600px'
    }} />
  }
]
};
export const PictureDescriptionDefinition = Definition;

export const PictureDescription =  ({onCompletion}: {onCompletion: () => void}) => {
  const getSubTasks = (option: string): SubTask[] => {
      console.log("Selected option:", option);
      const filteredSubTasks = option === 'option1'
        ? [Definition.subTaskDefinitions[0]]
        : [Definition.subTaskDefinitions[1]];

      return filteredSubTasks.map((definition) => ({
        ...definition,
        id: randomUUID(),
        instructions: translateReactNode(definition.instructions, Definition.cohort),
        title: translateReactNode(definition.title, Definition.cohort) as string
      }));
  };

  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: getSubTasks(Math.round(Math.random()) === 0 ? 'option1' : 'option2')
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
      />
    </div>
  );
}
